/* istanbul ignore file */
import * as z from 'zod';
import { defineMessages } from 'react-intl';

const validationMessages = defineMessages({
  descriptionError: {
    defaultMessage: 'Du musst eine Bewertung eingeben.',
    id: 'ratings.new-rating.reviewer-description-error',
  },
  descriptionTooShort: {
    defaultMessage: 'Bewertung ist zu kurz',
    id: 'ratings.new-rating.description-too-short',
  },
  descriptionTooLong: {
    defaultMessage: 'Bewertung ist zu lang',
    id: 'ratings.new-rating.description-too-long',
  },
  nicknameError: {
    defaultMessage: 'Du musst einen Nicknamen eingeben.',
    id: 'ratings.new-rating.reviewer-name-error',
  },
  nicknameTooShort: {
    defaultMessage: 'Name ist zu kurz',
    id: 'ratings.new-rating.name-too-short',
  },
  nicknameTooLong: {
    defaultMessage: 'Name ist zu lang',
    id: 'ratings.new-rating.name-too-long',
  },
  advantageError: {
    defaultMessage: 'Du musst mindestens einen Vorteil angeben.',
    id: 'ratings.new-rating.review-advantages-error',
  },
  disadvantageError: {
    defaultMessage: 'Du musst mindestens einen Nachteil angeben.',
    id: 'ratings.new-rating.review-disadvantages-error',
  },
  newRatingTermsError: {
    defaultMessage: 'Bitte akzeptiere unsere Nutzungsbedingungen.',
    id: 'ratings.new-rating.terms-error',
  },
});

export const ratingParser = z.number().min(1).max(5);

// TODO: find a better solution for translations in validation object
export const createRatingFormSchema = z.object({
  productId: z.string(),
  rating: ratingParser,
  title: z.string().optional(),
  location: z.string().optional(),
  name: z
    .string()
    .nonempty(JSON.stringify(validationMessages.nicknameError))
    .min(2, JSON.stringify(validationMessages.nicknameTooShort))
    .max(30, JSON.stringify(validationMessages.nicknameTooLong)),
  description: z
    .string()
    .nonempty(JSON.stringify(validationMessages.descriptionError))
    .min(5, JSON.stringify(validationMessages.descriptionTooShort))
    .max(300, JSON.stringify(validationMessages.descriptionTooLong)),
  accept: z.literal(true, {
    errorMap: () => ({
      message: JSON.stringify(validationMessages.newRatingTermsError),
    }),
  }),
  advantages: z.array(z.string()),
  disadvantages: z.array(z.string()),
});

export type CreateRatingFormSchema = z.infer<typeof createRatingFormSchema>;
